import React, { useEffect, useState } from 'react';
import Logo from '../../components/common/Logo';
import FriendRefferralRegisterForm from '../../components/Auth/FriendRefferralRegisterForm';
import { useNavigate, useLocation,Link } from 'react-router-dom';
import queryString from 'query-string';
import { validateStudent } from '../../actions/StudentAction';
import moment from 'moment';

const FriendRegister = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const date = moment().format('YYYY-MM-DD')
    const nextYear = moment(date).add(1, 'years').format('YYYY')


    const [studDetail, setStudResDetail] = useState({})
    const [isRegister, setIsRegister] = useState(true)
    const [msg, setMsg] = useState('')

    useEffect(async () => {
        if (sessionStorage.getItem('userDetail')) {
            navigate('/dashboard');
        }
        const qParams = queryString.parse(location.search);
        if (qParams !== null) {
            if (qParams.stud !== undefined) {
                const studRes = await validateStudent(qParams.stud)
                if (studRes.status) {
                    setIsRegister(true)
                    setStudResDetail(studRes.data)
                }
                else {
                    setIsRegister(false)
                    setMsg(studRes.message)
                }
            }
        }
    }, []);

    return (
        <section className="py-4 register-page">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 text-center">
                        <div className="both_logo_wrapper">
                            <a href='https://www.allenoverseas.com' target="_blank" title="ALLEN Overseas - Coaching Classes for JEE, NEET & Foundation">
                                <Logo alt="Logo" className="mb-4"/>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">

                    <div className="col-lg-10">

                        <div className="register-box">
                            <div className="page-head">
                                <h2>Tallentex Registration</h2>
                            </div>

                            <h4 className='text-dark text-center px-5 py-4'>Registrations have been closed for Tallentex 2023.<br/> Thanks for your overwhelming response!</h4>

                                <p className='text-muted'><b className='text-danger'>Important: </b>If you are already associated or an existing student of the ALLEN Overseas, then login using your existing ALLEN Overseas Email ID
                            & Password for TALLENTEX 2023 </p>

                            <h6 className='text-center fw-bold'>Click here to login <Link to="/login" className='text-decoration-underline'>Login</Link></h6>

                            {/* {isRegister && <FriendRefferralRegisterForm detail={studDetail != null && studDetail} />}

                            {msg.length > 0 && <div className='invalidFeedback'>{msg}</div>} */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}


export default FriendRegister;